"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useNav } from "@/providers/Nav";

export default function SetMainNavVisibility({ show = true }: { show?: boolean }) {
  const { setShowMainNav } = useNav();
  const pathname = usePathname();

  useEffect(() => {
    // Set per page/route change
    setShowMainNav(!!show);
    return () => {
      // Reset to default when unmounting, to avoid bleed
      setShowMainNav(true);
    };
    // Re-run when pathname changes or value changes
  }, [pathname, show, setShowMainNav]);

  return null;
}
